const moment = require('moment');

module.exports = ad => {
  const now = moment();
  const start = moment(ad.start_time);
  const end = moment(ad.end_time);
  return moment().isAfter(start) && moment().isBefore(end);
}
